import BaseSetup from '@/components/BaseSetup';
import { ref, watch } from 'vue';

export type SharedFlatSelectEmits = {
	(e: 'new'): void
	(e: 'delete' | 'add', val: FlatSelectOptionItem): void
	(e: 'update:search', val: string | undefined): void
};

export type SharedFlatSelectProps = {
	loading?: boolean
	showSearch?: boolean
	popoverOpened?: boolean
	modelValue?: number[]
	partial?: number[]
	options?: FlatSelectOptionItem[]
	search?: string
	selectedFunction?: (item: FlatSelectOptionItem) => boolean
	partialFunction?: (item: FlatSelectOptionItem) => boolean
	newLabel?: string
};

export default class SharedFlatSelectSetup extends BaseSetup {

	static readonly defaultProps = {
		modelValue: () => [] as number[],
		partial: () => [] as number[],
		options: () => [] as FlatSelectOptionItem[],
	};

	readonly _search = ref<OrionInput>();

	get searchTerm () { return this.props.search }
	set searchTerm (val) { this.emits('update:search', val) }

	constructor (
		private props: SharedFlatSelectProps,
		private emits: SharedFlatSelectEmits,
	) {
		super();

		watch(() => this.props.popoverOpened, (isOpen) => {
			if (isOpen) {
				setTimeout(() => this._search.value?.focus(), 100);
			}
		});
	}

	itemIsSelected (item: FlatSelectOptionItem) {
		if (!!this.props.selectedFunction) return this.props.selectedFunction(item);
		return !!(this.props.modelValue ?? []).find((x: number) => x === item.id);
	}

	itemIsPartialSelected (item: FlatSelectOptionItem) {
		if (!!this.props.partialFunction) return this.props.partialFunction(item);
		return !!(this.props.partial ?? []).find((x: number) => x === item.id);
	}

	async selectItemAsync (item: FlatSelectOptionItem) {
		if (this.itemIsSelected(item)) {
			this.emits('delete', item);
		}
		else {
			this.emits('add', item);
		}
	}

}
